import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'
import { getCalendarRange, groupByDay } from './calendarHelpers'

export type CalendarView = 'month' | 'week' | 'day'

export function useCalendar(view: CalendarView, currentDate: Date) {
  const { start, end } = useMemo(() => getCalendarRange(currentDate, view), [currentDate, view])

  const { data, isLoading } = useQuery({
    queryKey: ['appointments', 'calendar', start, end],
    queryFn: () => api.getAppointments({ startDate: start, endDate: end }),
    staleTime: 5 * 60 * 1000,
  })

  const items = data?.items || []
  const byDay = useMemo(() => groupByDay(items), [items])

  return {
    startDate: start,
    endDate: end,
    items,
    byDay,
    isLoading,
  }
}
